import { useState } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import EditableText from "utils/edit/EditableText";
import { ChangeEvent, Event } from "utils/history/Event";

import { Competence } from "core/blueprint/competencelist/CompetenceListService";
import CompetenceExpansion from "./CompetenceExpansion";

export type CompetenceRowProps = {
	index: number;
	criterion: Competence;
	editable: boolean;
	selected: boolean;
	labels?: string[];

	onSelect: (select: boolean) => void;
	onChange: (event: Event) => void;
};

export type FieldBaseRowProps = CompetenceRowProps & {
	children?: React.ReactNode;
};

const CompetenceRow: React.FC<CompetenceRowProps> = (
	props: CompetenceRowProps
) => {
	const { t } = useTranslation();

	const [expanded, setExpanded] = useState(false);

	function updateCriterionDescription(newName: string): void {
		if (newName !== "") {
			const event = new ChangeEvent(
				"/description",
				props.criterion.description,
				newName
			);
			props.onChange(event);
		}
	}

	return (
		<>
			<TableRow sx={{ "& > td": { borderBottom: "unset" } }}>
				<TableCell align="center" padding="checkbox">
					<Checkbox
						disabled={!props.editable}
						checked={props.selected}
						onChange={(_event, checked) => props.onSelect(checked)}
					/>
				</TableCell>
				<TableCell>{props.index + 1}</TableCell>
				<TableCell padding="checkbox">
					<IconButton onClick={() => setExpanded(!expanded)}>
						{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
					</IconButton>
				</TableCell>
				<TableCell
					sx={{
						paddingTop: 0,
						paddingBottom: 0,
						alignContent: "center"
					}}>
					<EditableText
						value={props.criterion.description}
						editable={props.editable}
						onChange={updateCriterionDescription}
					/>
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell
					style={{ paddingBottom: 0, paddingTop: 0 }}
					colSpan={6}>
					<Collapse in={expanded} timeout="auto" unmountOnExit>
						<Box sx={{ margin: 1 }}>
							<CompetenceExpansion
								criterion={props.criterion}
								editable={props.editable}
								labels={props.labels}
								onChange={props.onChange}
							/>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
};

export default CompetenceRow;
